class VideoMedia extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector("video");
    if (!this.video) return;

    this.playToggle = this.querySelector("[data-play-toggle]");
    this.muteToggle = this.querySelector("[data-mute-toggle]");

    this.iconPlay = this.querySelector("[data-icon-play]");
    this.iconPause = this.querySelector("[data-icon-pause]");
    this.iconUnmuted = this.querySelector("[data-icon-unmuted]");
    this.iconMuted = this.querySelector("[data-icon-muted]");

    this.onPlay = this.handlePlay.bind(this);
    this.onPause = this.handlePause.bind(this);
    this.onPlayClick = this.togglePlay.bind(this);
    this.onMuteClick = this.toggleMute.bind(this);
    this.onVolumeChange = this.handleVolumeChange.bind(this);

    this.video.addEventListener("play", this.onPlay);
    this.video.addEventListener("pause", this.onPause);
    this.video.addEventListener("volumechange", this.onVolumeChange);

    if (this.playToggle) {
      this.playToggle.addEventListener("click", this.onPlayClick);
    }

    if (this.muteToggle) {
      this.muteToggle.addEventListener("click", this.onMuteClick);
    }

    // Sync initial state
    this.syncPlayState();
    this.syncMuteState();
  }

  disconnectedCallback() {
    if (!this.video) return;

    this.video.removeEventListener("play", this.onPlay);
    this.video.removeEventListener("pause", this.onPause);
    this.video.removeEventListener("volumechange", this.onVolumeChange);

    if (this.playToggle) {
      this.playToggle.removeEventListener("click", this.onPlayClick);
    }

    if (this.muteToggle) {
      this.muteToggle.removeEventListener("click", this.onMuteClick);
    }
  }

  syncPlayState() {
    const playing = !this.video.paused;
    this.toggleAttribute("data-playing", playing);
    if (this.iconPlay) this.iconPlay.hidden = playing;
    if (this.iconPause) this.iconPause.hidden = !playing;
  }

  syncMuteState() {
    const muted = this.video.muted;
    this.toggleAttribute("data-muted", muted);
    if (this.iconUnmuted) this.iconUnmuted.hidden = muted;
    if (this.iconMuted) this.iconMuted.hidden = !muted;
  }

  handlePlay() {
    this.syncPlayState();
  }

  handlePause() {
    this.syncPlayState();
  }

  handleVolumeChange() {
    this.syncMuteState();
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    this.syncMuteState();
  }
}

if (!customElements.get("video-media")) {
  customElements.define("video-media", VideoMedia);
}
